<template>
  <div class="striped flex flex-col justify-between w-full">
    <template v-if="$mq === 'sm'">
      <contract-note-cell
        :note="note"
        :key="`note_${i}`"
        v-for="(note, i) in notes"
      />
    </template>
    <bdg-table-view class="mt-8" :rows="notes" :columns="columns">
      <template #beside-pagination>
        <bdg-button
          class="ghost has-icon w-full md:w-auto uppercase"
          before-icon-class="fal fa-plus-square"
          @click.native="addNote"
        >
          add note
        </bdg-button>
      </template>
    </bdg-table-view>
  </div>
</template>

<script>
import BdgButton from "../../elements/BdgButton";
import BdgTableView from "../../elements/table-view/BdgTableView";
import ContractNoteCell from "../../elements/list-view/list-view-cells/contract-cells/ContractNoteCell";
import IconCell from "../../elements/table-view/special-cells/IconCell";
import ContractNoteForm from "./forms/ContractNoteForm";
import { ContractSubEntityIcons } from "../../js-data/icon-maps";
import GenericDeleteModal from "../../components/modals/GenericDeleteModal";

export default {
  name: "ContractNotes",
  components: { ContractNoteCell, BdgTableView, BdgButton },
  data() {
    return {
      contractId: parseInt(this.$route.params.id, 10),
      columns: [
        { label: "", property: "text", additionalCellClasses: "w-3/4" },
        {
          label: "",
          property: "icon",
          cellComponent: IconCell,
          additionalCellClasses: "text-blue text-xl"
        },
        {
          label: "",
          property: "actions",
          actions: [
            {
              label: "edit",
              clickAction: note => {
                this.$store.commit("setCreateEditComponentParams", {
                  createEditComponent: ContractNoteForm,
                  createEditComponentData: {
                    ...note,
                    contract_id: this.contractId
                  },
                  createEditComponentIsShown: true
                });
              }
            },
            {
              label: "delete",
              clickAction: note => {
                this.$store.commit("setConfirmationModalParams", {
                  type: "delete",
                  headerText: "Delete Confirmation",
                  bodyComponent: GenericDeleteModal,
                  bodyComponentData: {
                    entityName: "note",
                    deleteFunction: () =>
                      this.$store.dispatch("deleteNote", note)
                  },
                  isShown: true
                });
              }
            }
          ],
          additionalCellClasses: "w-px whitespace-no-wrap"
        }
      ]
    };
  },
  computed: {
    notes() {
      const notes = this.$store.state.Contracts.Notes.contractNotes;
      if (notes) {
        return notes.map(note => {
          note.icon = {
            iconClasses: ContractSubEntityIcons[note.annotatable_type]
          };

          return note;
        });
      }
      return notes;
    }
  },
  created() {
    this.$store.dispatch("getContractNotes", this.contractId);
  },
  methods: {
    addNote() {
      this.$store.commit("setCreateEditComponentParams", {
        createEditComponent: ContractNoteForm,
        createEditComponentData: { contract_id: this.contractId },
        createEditComponentIsShown: true
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.striped {
  & > div:nth-child(even) {
    @apply bg-gray-100;
  }
}
</style>
